import * as React from 'react'
import * as api from '@owl-nest/api-client/next'

export type AccessControlContext = { project: api.Project; role: api.UserRole; isStaff: boolean }

export const accessControlContext = React.createContext<AccessControlContext | undefined>(undefined)
